import { DatePicker as DatePickerMUI } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { memo } from "react";
import { Controller, useFormContext } from "react-hook-form";
const DatePicker = ({ name, label, rules }) => {
  const { control } = useFormContext();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <DatePickerMUI
            {...field}
            inputRef={ref}
            format="DD/MM/YYYY"
            label={label}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                error: !!error,
                helperText: error?.message,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default memo(DatePicker);
